import script from "./WondeSync.vue?vue&type=script&setup=true&lang=js"
export * from "./WondeSync.vue?vue&type=script&setup=true&lang=js"

import "./WondeSync.vue?vue&type=style&index=0&id=0025a1ac&lang=css"

const __exports__ = script;

export default __exports__